"use strict";
// Copyright 2019 Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZoomType = void 0;
var ZoomType;
(function (ZoomType) {
    ZoomType[ZoomType["ZOOM"] = 0] = "ZOOM";
    ZoomType[ZoomType["RESET"] = 1] = "RESET";
    ZoomType[ZoomType["NONE"] = 2] = "NONE";
})(ZoomType = exports.ZoomType || (exports.ZoomType = {}));
//# sourceMappingURL=PresentationPolicy.js.map